import { Box, LinkProps, Link as MuiLink, styled, Typography } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  padding: '8px 16px 32px',
  alignSelf: 'end',

  [theme.breakpoints.up('mobileLarge')]: {
    padding: '0 0 32px',
  },
}));

export const Text = styled(Typography)(({ theme }) => ({
  ...theme.typography['body-2'],
  color: theme.palette.grey[500],
  textAlign: 'center',
}));

export const Link = styled((props: LinkProps) => <MuiLink target="_blank" {...props} />)(({ theme }) => ({
  ...theme.typography['body-2'],
  color: theme.palette.grey[500],
  textDecoration: 'underline',
  cursor: 'pointer',
}));
